import type { PageProps } from 'gatsby';
import React from 'react';

import BigCircle from '@components/BigCircle';

import AdminManagement from '@views/Admin/Management';

export default function AdminPolicyDrilldownPage({ params }: PageProps) {
  const { id: policy_id } = params;

  return (
    <AdminManagement.Layout maxContentWidth="md">
      <BigCircle />
      <AdminManagement.Policies.Drilldown policy_id={policy_id} />
    </AdminManagement.Layout>
  );
}
